<template>
  <div>
    <template v-if="category && category.length > 0">
      <div class="caption">
        {{ category[0].name }}
      </div>
      <template v-for="(opt, oindex) in category[0].option">
        <product-option-item
          :level="0"
          v-model="value"
          :option="opt"
          :key="'option_' + opt + '_' + oindex"
          @onClick="onChangeOption(1, opt)"
          :stock="stock"
          :isSelected="option1 && option1 == opt"
          @focusOption="focusOption"
          @blurOption="$emit('blurOption')"
        >
          {{ opt }}
        </product-option-item>
      </template>
      <template v-if="category.length > 1">
        <div class="caption">
          {{ category[1].name }}
        </div>

        <template v-for="(opt, oindex) in category[1].option">
          <product-option-item
            v-if="checkStock(opt)"
            :level="1"
            v-model="value"
            :option="opt"
            :key="'option_' + opt + '_' + oindex"
            @onClick="onChangeOption(2, opt)"
            :stock="stock"
            :isSelected="option2 && option2 == opt"
            @focusOption="focusOption"
            @blurOption="$emit('blurOption')"
          >
            <!-- <v-avatar v-if="stype[7]">
                    <img :src="stype[7]" :alt="stype[1]" />
                </v-avatar>  -->
            {{ opt }}
          </product-option-item>
        </template>
      </template>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
const ProductOptionItem = () => import('./ProductOptionItem')
export default {
  props: ['value', 'category', 'stock'],
  computed: {
    ...mapGetters({
      theme: 'getTheme'
    })
  },
  components: {
    ProductOptionItem
  },
  data() {
    return {
      option1: null,
      option2: null
    }
  },
  mounted() {
    try {
      var options = this.value.split('/')
      this.option1 = options && options.length > 0 ? options[0] : null
      this.option2 = options && options.length > 1 ? options[1] : null
    } catch (error) {
      //
    }
  },
  methods: {
    checkStock(opt) {
      var result = this.stock.find((el) => el[1] == this.option1 + '/' + opt)

      if (result && result[2] !== '0') return true
      else false
    },
    focusOption(payload) {
      this.$emit('focusOption', payload)
    },
    onChangeOption(type, opt) {
      this['option' + type] = opt
      if (type == 1 && this.category.length > 1) {
        this.setdefaultNotEmptyStock()
      }
      this.updateOption()
    },
    setdefaultNotEmptyStock() {
      var result = this.stock.filter(
        (el) => el[1].split('/')[0] == this.option1
      )
      result = result.find((el) => el[2] != '0')
      this.option2 = result[1].split('/')[1]
    },
    updateOption() {
      if (this.category.length > 1) {
        if (this.option1 && this.option2) {
          this.$emit('input', `${this.option1}/${this.option2}`)
          this.$emit('changeOption', `${this.option1}/${this.option2}`)
        } else {
          this.$emit('input', null)
          this.$emit('changeOption', null)
        }
      } else {
        this.$emit('input', this.option1 ? this.option1 : null)
        this.$emit('changeOption', this.option1 ? this.option1 : null)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
